import Vue from 'vue'
import ParameterSetDialog from "./parameterSetDialog.vue";

const ParameterBox = Vue.extend(ParameterSetDialog);

ParameterSetDialog.install = function (data) {
  let instance = new ParameterBox({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
};

export default ParameterSetDialog



// WEBPACK FOOTER //
// ./src/components/popup/parameterSetDialog.js